import { render, staticRenderFns } from "./jxcdgl.vue?vue&type=template&id=8ac4973e&scoped=true"
import script from "./jxcdgl.vue?vue&type=script&lang=js"
export * from "./jxcdgl.vue?vue&type=script&lang=js"
import style0 from "./jxcdgl.vue?vue&type=style&index=0&id=8ac4973e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac4973e",
  null
  
)

export default component.exports